import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class CalendarServie {

  getCalendar() {
    return axios.get(apiUrl + 'calendar', { headers: authHeader() });
  }

  addEvent(event) {
    return axios.post(apiUrl + 'calendar', event, { headers: authHeader() });
  }

  sendInvite(invite) {
    return axios.post(apiUrl + 'calendar/invite', invite, { headers: authHeader() });
  }

  updateEvent(event) {
    return axios.put(apiUrl + 'calendar', event, { headers: authHeader() });
  }

  deleteEvent(id) {
    return axios.delete(apiUrl + 'calendar/' + id, { headers: authHeader() });
  }

  getMinTime() {
    let time = new Date()
    time.setHours(8)
    time.setMinutes(0)
    time.setSeconds(0)
    return time
  }

  getMaxTime () {
    let time = new Date()
    time.setHours(21)
    time.setMinutes(0)
    time.setSeconds(0)
    return time
  }
}

export default new CalendarServie();